import './SkipSystemPasswordOnboarding.css';

import React from 'react';

interface SkipSystemPasswordOnboardingButtonProps {
  onClick: () => void
}

export const SkipSystemPasswordOnboardingButton = ({ onClick }: SkipSystemPasswordOnboardingButtonProps): JSX.Element => {
  return (
    <div id="system_password_onboarding_skip_button" onClick={onClick}>Do this later</div>
  );
};
